// src/pages/UserManagement/UserPagination.tsx
// Kết nối state phân trang trong Redux (slice userManagement) với component
// PaginationBar dùng chung (Components/Common/PaginationBar).

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setPage, setPageSize } from 'slices/userManagement/reducer';
import PaginationBar from 'Components/Common/PaginationBar';

const UserPagination: React.FC = () => {
  const dispatch = useDispatch();

  const { pagination } = useSelector((state: any) => state.UserManagement);
  const { currentPage, pageSize, totalItems, totalPages } = pagination;

  return (
    <PaginationBar
      currentPage={currentPage}
      totalPages={totalPages}
      totalItems={totalItems}
      pageSize={pageSize}
      onPageChange={(page) => dispatch(setPage(page))}
      onPageSizeChange={(size) => dispatch(setPageSize(size))}
    />
  );
};

export default UserPagination;
